import FederationTemplateConfig from "../template";
import { merge } from "lodash-es";
import Colors, { quillColors } from "./colors";
export default class BelgiumFederation extends FederationTemplateConfig {
    constructor() {
        super();
        this.logo = {
            image: require("./logo.png"),
            label: "Equibel",
            backgroundColor: "gainsboro"
        };
        this.countryCode = "BE";
        this.locale = "en-BE";
        this.sprites = require("./belgium-sprites.svg");
        this.placeholderLogo = require("./placeholder-logo.png");
        this.webTitle = "Equibel";
        this.colors = merge(this.colors, Colors);
        this.quillColors = merge(this.quillColors, quillColors);
        this.heroBanner = null;
        this.documents = { paymentTermsOfService: null };
        this.links = {
            homepage: "https://www.equibel.be/",
            news: null,
            rulesPage: null
        };
    }
}
